import React from 'react';
import { useTranslation } from 'react-i18next';

const AccessRightsMatrix = () => {
  const { t } = useTranslation();
  return (
    <div className="row justify-content-center">
      <div className="col-12 col-xl-10">
        <h1 className="text-center text-dark mb-2 fw-semibold">
          {t('access_matrix_title')}
        </h1>
        <p className="text-center text-muted fst-italic mb-5">
          {t('access_matrix_subtitle')}
        </p>

        <div className="mb-5">
          <h2 className="text-dark border-bottom border-primary border-3 pb-2 mb-4">
            📋 {t('role_definition_title')}
          </h2>
          <div className="row g-3">
            <div className="col-md-6 col-lg-3">
              <div className="card bg-light border-1 h-100">
                <div className="card-body">
                  <h3 className="card-title h6 text-dark mb-2">
                    👤 {t('role_user_title')}
                  </h3>
                  <p className="card-text text-muted small mb-0">
                    {t('role_user_card_description')}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card bg-light border-1 h-100">
                <div className="card-body">
                  <h3 className="card-title h6 text-dark mb-2">
                    👥 {t('role_entity_admin_title')}
                  </h3>
                  <p className="card-text text-muted small mb-0">
                    {t('role_entity_admin_card_description')}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card bg-light border-1 h-100">
                <div className="card-body">
                  <h3 className="card-title h6 text-dark mb-2">
                    ⚙️ {t('role_admin_title')}
                  </h3>
                  <p className="card-text text-muted small mb-0">
                    {t('role_admin_card_description')}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card bg-light border-1 h-100">
                <div className="card-body">
                  <h3 className="card-title h6 text-dark mb-2">
                    🔧 {t('role_adv_admin_card_title')}
                  </h3>
                  <p className="card-text text-muted small mb-0">
                    {t('role_adv_admin_card_description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-5">
          <h2 className="text-dark border-bottom border-primary border-3 pb-2 mb-4">
            🔐 {t('permission_matrix_title')}
          </h2>

          <div className="d-flex flex-wrap justify-content-center gap-4 mb-4">
            <div className="d-flex align-items-center gap-2">
              <span className="text-success fw-bold">✅</span>
              <span className="small">{t('legend_access_allowed_label')}</span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <span className="text-danger fw-bold">❌</span>
              <span className="small">{t('legend_access_denied_label')}</span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <span className="text-warning fw-bold">🔒</span>
              <span className="small">
                {t('legend_access_restricted_label')}
              </span>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-hover bg-white rounded shadow-sm">
              <thead className="table-primary">
                <tr>
                  <th
                    className="text-start fw-semibold"
                    style={{ width: '35%' }}
                  >
                    {t('table_action_header')}
                  </th>
                  <th className="text-center fw-semibold">
                    👤
                    <br />
                    {t('role_user_title')}
                  </th>
                  <th className="text-center fw-semibold">
                    👥
                    <br />
                    {t('role_entity_admin_title')}
                  </th>
                  <th className="text-center fw-semibold">
                    ⚙️
                    <br />
                    {t('role_admin_title')}
                  </th>
                  <th className="text-center fw-semibold">
                    🔧
                    <br />
                    {t('table_adv_col')}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_access_faq')}
                  </td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                </tr>
                <tr className="table-secondary">
                  <td
                    colSpan="5"
                    className="fw-bold text-dark text-uppercase small"
                  >
                    {t('row_category_support_access')}
                  </td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_support_connection')}
                  </td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_son_entite_uniquement')}
                  </td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_son_entite_uniquement')}
                  </td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-danger fw-bold">❌</td>
                </tr>

                <tr className="table-secondary">
                  <td
                    colSpan="5"
                    className="fw-bold text-dark text-uppercase small"
                  >
                    {t('row_category_license_management')}
                  </td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_license_crud')}
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_license_list')}
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_son_entite_uniquement')}
                  </td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_license_edit_name')}
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_son_entite_uniquement')}
                  </td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                </tr>

                <tr className="table-secondary">
                  <td
                    colSpan="5"
                    className="fw-bold text-dark text-uppercase small"
                  >
                    {t('row_category_code_management')}
                  </td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_code_create')}
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-danger fw-bold">❌</td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_code_view')}
                  </td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-danger fw-bold">❌</td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_code_history')}
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_codes_created_by_user')}
                  </td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_codes_created_by_user')}
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_code_delete')}
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_codes_created_by_user')}
                  </td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_codes_created_by_user')}
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                </tr>

                <tr className="table-secondary">
                  <td
                    colSpan="5"
                    className="fw-bold text-dark text-uppercase small"
                  >
                    {t('row_category_user_management')}
                  </td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_user_management_full')}
                    <br />
                    <small>{t('row_crud_small')}</small>
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-warning fw-bold small">
                    🔒
                    <br />
                    {t('label_son_entite_uniquement')}
                  </td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-danger fw-bold">❌</td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_user_profile_edit')}
                  </td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-success fw-bold">✅</td>
                </tr>

                <tr className="table-secondary">
                  <td
                    colSpan="5"
                    className="fw-bold text-dark text-uppercase small"
                  >
                    {t('row_category_entity_management')}
                  </td>
                </tr>
                <tr>
                  <td className="bg-light fw-medium text-dark">
                    {t('row_entity_management_full')}
                    <br />
                    <small>{t('row_crud_small')}</small>
                  </td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-danger fw-bold">❌</td>
                  <td className="text-center text-success fw-bold">✅</td>
                  <td className="text-center text-danger fw-bold">❌</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="mb-5">
          <h2 className="text-dark border-bottom border-primary border-3 pb-2 mb-4">
            📝 {t('important_notes_title')}
          </h2>
          <ul className="text-dark lh-lg">
            <li>
              <strong>{t('note_entity_restriction_title')}</strong>
              {t('note_entity_restriction')}
            </li>
            <li>
              <strong>{t('note_codes_title')}</strong>
              {t('note_codes')}
            </li>
            <li>
              <strong>{t('note_support_license_title')}</strong>
              {t('note_support_license')}
            </li>
            <li>
              <strong>{t('note_adv_role_title')}</strong>
              {t('note_adv_role')}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AccessRightsMatrix;
